let baseHoverDelegate = {
    showHover: () => undefined,
    hideHover: () => undefined,
    showAndFocusLastHover: () => undefined,
    setupUpdatableHover: () => null,
};
function setBaseLayerHoverDelegate(hoverDelegate) {
    baseHoverDelegate = hoverDelegate;
}
function getBaseLayerHoverDelegate() {
    return baseHoverDelegate;
}
export { getBaseLayerHoverDelegate, setBaseLayerHoverDelegate };
